import { MOBILE_SCREEN_QUERY } from "../../js/shared.3c04262e7f5d.js";
import TomSelect from "../../js/tom-select/tom-select.0c9bda91e62b.js";
import { createOptionRenderer } from "./pet-tomselect-utils.b93c6b1d8b56.js";
import { addTomSelectAriaLabel } from "../../js/fancy-dropdowns.3e2d7c0fd3ef.js";
import { FloatingLabel } from "../../js/floating-label.895f0e243516.js";

class PetLocationSelector extends HTMLElement {
  constructor() {
    super();
    this.displayDisabled = this.hasAttribute("data-display-disabled");
    this.standalone = this.hasAttribute("data-standalone");
  }

  connectedCallback() {
    this.locationSelectorEl = this.querySelector("select");
    this.parentEl = this.locationSelectorEl.parentElement;
    // store a reference to this PetLocationSelector instance,
    // so its properties can be accessed inside the TomSelect instance
    const that = this;
    this.dropdown = new TomSelect(this.locationSelectorEl, {
      dropdownParent: this.parentEl,
      labelField: "label",
      duplicates: true,
      onDropdownClose: () => {
        if (document.activeElement === this.dropdown.control_input) {
          this.advance();
        }
      },
      render: {
        option: createOptionRenderer(that.displayDisabled),
      },
    });

    addTomSelectAriaLabel(this.locationSelectorEl, this.dropdown);

    this.dropdown.on("change", this.advance);

    FloatingLabel.withTomSelect(this, this.dropdown);
  }

  advance = (e) => {
    if (this.standalone || MOBILE_SCREEN_QUERY.matches) {
      document.activeElement.blur();
    } else {
      const insuranceSelector = document.getElementById("pet-insurance");
      insuranceSelector.focus();
    }

    document.dispatchEvent(
      new CustomEvent("tqc:pet-location-changed", {
        detail: {
          providerId: this.dropdown.getValue(),
          label: this.dropdown.activeOption.textContent,
        },
        bubbles: true,
      }),
    );
  };
}

window.customElements.define("pet-location-selector", PetLocationSelector);
